export default __webpack_public_path__ + "static/media/whyPage-whatTab.edaf7e1b.svg";